import { Link, useLocation } from 'react-router-dom';
import '../styles.css'
import { titleCase } from '../../utils/utils';

interface IBreadcrumbsNamedProps {
    baseName?: string;
}

const Breadcrumbs = ({ baseName = '' }: IBreadcrumbsNamedProps) => {
    const location = useLocation();
    let currentLink = "";

    const decodedPathname = location.pathname;
    const expresionRegular = /id(\d+)/;

    const stopCrumbs = ['ods', 'grupos-prioritarios'];

    const pathSegments = decodedPathname.split('/').filter((crumb) => crumb !== '');
    const stopIndex = pathSegments.findIndex(
        (crumb, idx) => stopCrumbs.includes(crumb) && idx < pathSegments.length - 1
    );
    const visibleCrumbs = stopIndex !== -1 ? pathSegments.slice(0, stopIndex + 1) : pathSegments;

    // --- Query params informes ---
    const searchParams = new URLSearchParams(location.search);
    const relatedIndicatorTitle = searchParams.get("related_indicator_title");

    // --- Armar los crumbs base ---
    const crumbs = visibleCrumbs.map((crumb, index, array) => {
        currentLink += `/${crumb}`;

        const isCurrentLink = currentLink === location.pathname;
        let crumbText = titleCase(
            decodeURIComponent(crumb.replaceAll('-', ' ').replace(expresionRegular, ''))
        );

        if (crumb === 'que-es') crumbText = '¿Qué es?';
        if (crumb === 'metodologia') crumbText = baseName;

        const isLast = index === array.length - 1;

        return (
            <p key={crumb} className="flex gap-1">
                {index > 0 && " / "}
                {isLast ? (
                    <span className="text-brand-green-40  truncate max-w-64 sm:max-w-80 lg:max-w-full block">
                        {crumbText}
                    </span>
                ) : (
                    <Link
                        to={currentLink}
                        className={isCurrentLink ? "text-[#70787D] lg:max-w-full block" : ""}
                    >
                        {crumbText}
                    </Link>
                )}
            </p>
        );
    });

    // --- Si es informes con related_indicator_title ---
    if (decodedPathname.includes("/informes") && relatedIndicatorTitle) {
        crumbs[crumbs.length - 1] = (
            <p key="informes-link" className="flex gap-1">
                {" / "}
                <Link
                    to={currentLink}
                    className="text-[#70787D] lg:max-w-full block"
                >
                    Informes
                </Link>
            </p>
        );

        crumbs.push(
            <p key="related-informes" className="flex gap-1">
                {" / "}
                <span className="text-primary-40 truncate max-w-64 sm:max-w-80 lg:max-w-full block">
                    {`${decodeURIComponent(relatedIndicatorTitle)}`}
                </span>
            </p>
        );
    }

    return (
        <div className="flex flex-wrap gap-1 text-tsmall md:text-tmedium text-[#70787D]">
            Defensoría / {crumbs}
        </div>
    );
};

export default Breadcrumbs;